


define(['angular', 'text!./template.html', 'components/xo-title/dist/directive', 'components/xo-models/src/marketingoffer/index', 'components/xo-models/src/checkout/index', 'components/xo-models/src/auth/index'], function (angular, template) {

    return angular.module('xo-page-components.marketingOffers', ['squid', 'xo-title.directive', 'xomodel.marketingoffer', 'xomodel.checkout', 'xomodel.auth']).directive('xoMarketingOffers', function () {
        return {
            template: template,

            scope: {
                placementCode: '=',
                titleTxtProperty: '=',
                subtitleProperty: '=',
                token: '=',
                pageName: '=',
                backgroundImage: '='
            },

            controller: function controller($scope, $sce, $rootScope, $populate, $state, $locale, $renderContent, $logger, $pxp, $config, $CheckoutCartModel, $MarketingOfferModel, $fireMORSBeacon, $element, $feature, $CheckoutSessionModel, $CheckoutPayeeModel, $AuthModel) {
                var morsOfferFlag = $scope.placementCode === '202003' && $feature('morsValuePropOffers');
                var populateObj;
                if (morsOfferFlag) {
                    populateObj = {
                        checkoutCart: $CheckoutCartModel.instance($scope.token),
                        checkoutSession: $CheckoutSessionModel.instance($scope.token),
                        payee: $CheckoutPayeeModel.instance($scope.token),
                        auth: $AuthModel.instance()
                    };
                } else {
                    populateObj = {
                        checkoutCart: $CheckoutCartModel.instance($scope.token)
                    };
                }
                $populate($scope, populateObj).then(function () {
                    $scope.locale = $locale;
                    $scope.token = $rootScope.token;
                    function setDefaultValues() {
                        $scope.ad = {
                            Title: $renderContent($scope.titleTxtProperty),
                            Body: $renderContent($scope.subtitleProperty),
                            backgroundImage: $scope.backgroundImage
                        };
                    }

                    $scope.$watch('ad.backgroundImage', function (imageUrl) {
                        if (imageUrl) {
                            var url = imageUrl;
                            var propImg = angular.element($element[0].querySelector('div.prop-img'));
                            var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;

                            if (isRetina && url) {
                                var index = url.lastIndexOf('.'); // index at which file extension start
                                url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
                                propImg.css({
                                    'background-image': 'url(' + url + ')',
                                    'height': '150px',
                                    'margin-top': '0px'
                                });
                            } else {
                                propImg.css({
                                    'background-image': 'url(' + url + ')',
                                    'height': '150px',
                                    'margin-top': '0px'
                                });
                            }
                        }
                    });

                    if ($scope.placementCode === '202002') {
                        $scope.pu_type = 'ANONYMOUS';
                        $scope.presentation_types = ['CompositeText'];
                        $scope.pxpInfo = {
                            name: 'xo_xoon_hermes_mors',
                            pattern: '(xo_xoon_hermes_mors_)(.*)',
                            treatment: 'xo_xoon_hermes_mors_treatment'
                        };
                    } else if ($scope.placementCode === '202003') {
                        $scope.className = 'props';
                        $scope.pu_type = 'PERSONAL';
                        $scope.presentation_types = ['GenericComposite'];
                        $scope.pxpInfo = {
                            name: 'xo_mors_hermes_placements_ryi',
                            pattern: '(xo_mors_hermes_placements_ryi_)(.*)',
                            treatment: 'xo_mors_hermes_placements_ryi_treatment'
                        };
                    } else {
                        setDefaultValues();
                    }

                    //  serve ads only if pxp is true, country is US and lang is en
                    if ($locale.country === 'US' && $locale.lang === 'en' && $scope.placementCode && $feature('morsValuePropOffers')) {
                        $scope.marketingOfferData = new $MarketingOfferModel({
                            countryCode: $scope.locale.country,
                            page: $scope.pageName,
                            puType: $scope.pu_type,
                            locale: $locale.lang + '_' + $locale.country,
                            totalTransactionAmount: {
                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                                // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
                                // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
                                'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
                            },
                            totalShippingAmount: {
                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                                // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)        
                                // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html                            
                                'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
                            },
                            payee: morsOfferFlag ? $scope.payee.merchant.id : '',
                            payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
                            si: morsOfferFlag ? $scope.checkoutSession.id : '',
                            visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
                            targetPlacements: [{
                                'placement_code': $scope.placementCode,
                                'presentation_types': $scope.presentation_types
                            }]
                        });
                        $pxp($scope.pxpInfo.name, { 'ctx.COUNTRY': $locale.country }, $scope.pxpInfo.pattern).then(function (res) {

                            $logger.info('MO treatment: ' + (res ? res.treatment_name : '[no pxp response!]'));
                            if (res && res.treatment_name === $scope.pxpInfo.treatment) {

                                return $MarketingOfferModel.instance($scope.token).save({

                                    silent: true,
                                    data: $scope.marketingOfferData.serialize(),
                                    success: function success(result) {
                                        var ads_arr = result && result.ads || [];
                                        var adFound = false;

                                        // MORS could serve multiple ads for a given page. Iterate to get the
                                        // correct one based on the ad placement_id
                                        ads_arr.forEach(function (ad) {
                                            var adunit_id = ad.campaign.adunit_id;

                                            if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
                                                adFound = true;
                                                $scope.ad = {};
                                                var content = ad.content.nvp;
                                                content.forEach(function (obj) {
                                                    $scope.ad[obj.name] = obj.value;
                                                });
                                                $scope.ad['impressionUrl'] = ad.tracking.impression_url;
                                                $scope.ad['clickUrl'] = ad.tracking.click_url;
                                            }
                                        });

                                        if (adFound) {
                                            $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
                                            // $scope.ad.Title does not need to be assigned. for 202001, 202002,
                                            // and 202003 placement_ids as this will already be assigned.

                                            // notify MORS of successful rendering by firing the impressionurl
                                            // beacon and by setting the click url to be fired for future
                                            // conversion.
                                            // setting the placement_id helps to differentiate between multiple ads
                                            // displayed on the same page

                                            $logger.info('MORS_ad_displayed');
                                            $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);

                                            $rootScope.$broadcast('MORSDisplayed', {
                                                clickUrl: $scope.ad.clickUrl,
                                                placementId: $scope.placementCode
                                            });
                                        } else {
                                            $logger.info('MORS_ad_not_found');
                                            setDefaultValues();
                                            $rootScope.$broadcast('MORSNotDisplayed');
                                        }
                                    },

                                    error: function error(err) {
                                        setDefaultValues();
                                        $logger.error('MORS_api_failure', { error: err });
                                    }
                                });
                            } else {
                                setDefaultValues();
                                $rootScope.$broadcast('MORSNotDisplayed');
                            }
                        });
                    } else {
                        setDefaultValues();
                        $rootScope.$broadcast('MORSNotDisplayed');
                    }
                    $scope.$on('localeChange', function () {
                        setDefaultValues();
                    });
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/marketingOffers/directive.js
// module id = ./components/xo-page-components/src/marketingOffers/directive.js
// module chunks = 1